const { CONSTANTS } = require('../../config')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {number|string} value
 * @param {string} country
 * @returns {string|undefined}
 */
function phone (value, country) {
  if (!value) return ''

  let val = value
    .toString()
    .replace(/[^0-9]+/g, '')

  const constants = CONSTANTS[country?.toUpperCase()]
  if (!constants) return value

  if (val.length >= constants.PHONE_NO_GROUPING.MIN_LENGTH) {
    val = val
      .replace(
        constants.PHONE_NO_GROUPING.REGEX,
        constants.PHONE_NO_GROUPING.OUTPUT
      )
  }

  return val
}

module.exports = { phone }
